import NAME from "./constants";

export const getQuantityPerScreen = store => store[NAME].quantityPerScreen || {};
export const getAutomaticProcessesIsEnabled = store => store[NAME].isEnabled;
export const loading = store => store[NAME].isLoading;
